"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var Parser_1 = require("../Parser");
var ShopContext_1 = require("./ShopContext");
var hooks_1 = require("preact/hooks");
var color_1 = require("../common/color");
var ShopTitle = function () {
    var _a = (0, hooks_1.useContext)(ShopContext_1.default), colors = _a.colors, optionIndex = _a.optionIndex, options = _a.options;
    return ((0, preact_1.h)("div", { class: "shop-v2__title", style: { color: (0, color_1.toHex)(colors.productTitle) } }, (0, Parser_1.parse)(options[optionIndex].title.value)));
};
exports.default = ShopTitle;
